<div class="banner">

  <div class="ui container">


    <div class="pre-banner-title">
      BUILT FOR
    </div>

    <div class="banner-title">
      Curriculum Mapping
    </div>
    <div class="banner-subtitle">
      <span>Curriculum Links</span> is an online tool designed to make curriculum mapping
      simple and easy
    </div>

  </div>

</div>


<div class="section what-is">


  <div class="ui container">

    <div class="ui stackable grid">
      <div class="five wide column left-col">
        <div class="title-light">WHAT IS</div>
        <div class="title-heavy">Curriculum Mapping?</div>
      </div>
      <div class="eleven wide column right-col">
        The process of associating course outcomes with program-level learning outcomes and aligning elements of
        courses (e.g. teaching and learning activities, assessment strategies) within a program, to ensure that it is
        structured in a strategic, thoughtful way that enhances student learning (Dyjur & Kalu, 2017).
      </div>
    </div>


    <!-- <table>
      <tr>
        <td class="left-col">
          <div class="title-light">WHAT IS</div>
          <div class="title-heavy">Curriculum Mapping?</div>
        </td>
        <td class="right-col">
          The process of associating course outcomes with program-level learning outcomes and aligning elements of
          courses (e.g. teaching and learning activities, assessment strategies) within a program, to ensure that it is
          structured in a strategic, thoughtful way that enhances student learning (Dyjur & Kalu, 2017).
        </td>
      </tr>
    </table> -->

  </div>

</div>


<div class="section curriculum-links">


  <div class="ui container">

    <div class="pre-header">ABOUT</div>
    <div class="cl-header">Curriculum Links</div>
    <div class="cl-description">Curriculum links is an online application that collects course-level data for a
      program. Once all courses have been mapped, the data can be collated to produce curriculum maps. </div>

    <div class="features">


      <div class="ui stackable grid">

        <div class="four wide column feature">
          <i class="tasks icon"></i>
          <div class="feature-title">
            Easy step-by-step process
          </div>
          <div>
            Easily follow the steps to set up a curriculum mapping project
          </div>

        </div>
        <div class="four wide column feature">
          <i class="chart bar icon"></i>
          <div class="feature-title">
            Customizable Program Reports
          </div>
          <div>
            Generate multiple reports using different subsets of the data
          </div>
        </div>
        <div class="four wide column feature">
          <i class="file alternate outline icon"></i>
          <div class="feature-title">
            Individual course reports
          </div>
          <div>
            Create individual course reports for instructors to analyze their courses
          </div>
        </div>

        <div class="four wide column feature">
          <i class="cog icon"></i>
          <div class="feature-title">
            Flexible Configuration
          </div>
          <div>
            Customizable settings for your unique projects
          </div>
        </div>

      </div>

    </div>

  </div>

</div>


<div class="section steps">

  <div class="ui container">

    <div class="steps-pre-header">HOW TO</div>
    <div class="steps-header">Use Curriculum Links</div>





    <div>
      <div>
        <div class="ui stackable grid">
          <div class="three column row">

            <div class="column">
              <div class="ui grid">
                <div class="four wide column step-number">
                  <span class="ui white circular label massive">1</span>
                </div>
                <div class="twelve wide column ">
                  <div class="step-title">
                    Create a new curriculum project
                  </div>
                  <div class="step-desc">
                    Administrator creates a new curriculum project and assigns courses to instructors.
                  </div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="ui grid">
                <div class="four wide column step-number">
                  <span class="ui white circular label massive">2</span>
                </div>
                <div class="twelve wide column ">
                  <div class="step-title">
                    Map courses to program
                  </div>
                  <div class="step-desc">
                    Instructors map their courses.
                  </div>
                </div>
              </div>
            </div>

            <div class="column">
              <div class="ui grid">
                <div class="four wide column step-number">
                  <span class="ui white circular label massive">3</span>
                </div>
                <div class="twelve wide column ">
                  <div class="step-title">
                    Generate reports
                  </div>
                  <div class="step-desc">
                    Administrators create reports using aggregated data.
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>


    </div>
  </div>
</div>


<!-- <div class="section project-timeline">

  <div class="ui container">
    <div class="ui stackable grid">

      <div class="six wide column">
        <div class="pre-header">PROJECT</div>
        <div class="timeline-header">Timeline</div>
        <div class="timeline-desc">
          Curriculum Links is currently being developed by a team in the Taylor Institute for Teaching and Learning,
          University of Calgary. This project is in the pilot phase and will be launched in March 2019.
        </div>
      </div>
      <div class="ten wide column timeline-column">

        <div class="timeline-item" date-is='Summer 2018'>

          <div class="timeline-item-header">Testing</div>

        </div>


        <div class="timeline-item" date-is='October 2018'>

          <div class="timeline-item-header">Pilot</div>
          <p>
            We will be piloting Curriculum Links for selected programs. If you are interested in participating the
            pilot, please contact us.
          </p>
        </div>

        <div class="timeline-item" date-is='December 2018'>

          <div class="timeline-item-header">Phase I</div>
          <p>
            Curriculum Links will be initially available to UCalgary community.
          </p>
        </div>


      </div>

    </div>
  </div>




</div> -->



<div class="section about-ti">



  <div class="ui container">

    <div class="ui stackable grid">

      <div class="five wide column">
        <div class="ti-pre-header">ABOUT US</div>
        <div class="ti-header">Taylor Institute for Teaching and Learning</div>
      </div>

      <div class="eleven wide column ti-description">
        Taylor Institute for Teaching and Learning supports building and sharing teaching expertise; integrating
        technologies to enhance learning;
        and conducting inquiry to improve student learning. Through the College of Discovery and Innovation, the Taylor
        Institute offers undergraduate students opportunities for inquiry-based learning, experiential learning and
        interdisciplinary research.
        <br><br>
        For more information about Taylor Institute for Teaching and Learning, please visit <a href="https://taylorinstitute.ucalgary.ca/"
          target="_blank">https://taylorinstitute.ucalgary.ca</a>.

      </div>

    </div>

  </div>

</div>

<div class="section contact">
  <div class="contact-pre-header">CONTACT US</div>
  <div class="contact-header">
    Questions?
  </div>
  <div class="contact-desc">
    <div>Please email:</div>
    <div class="email">curriculumlinks@ucalgary.ca</div>
  </div>
</div>
